// import {UpdateToast} from "@/providers";

const DCUtil = {
    executeFunctionByName(functionName) {
        var args = Array.prototype.slice.call(arguments, 1);
        var namespaces = functionName.split(".");
        var func = namespaces.pop();
        var context = window;
        for (var i = 0; i < namespaces.length; i++) {
            context = window[namespaces[i]];
        }
        return context[func].apply(context, args);
    },

    getFullPropertyName(prop) {
        switch (prop) {
            case 'x':
                return 'left';
            case 'y':
                return 'top';
            case 'h':
                return 'height';
            case 'w':
                return 'width';
            default:
                return null;
        }
    },

    getSmallPropertyName(prop) {
        switch (prop) {
            case 'left':
                return 'x';
            case 'top':
                return 'y';
            case 'height':
                return 'h';
            case 'width':
                return 'w';
            default:
                return null;
        }
    },

    //no plugin (abaixo) tem outra forma

    round2(num) {
        let r = Math.round;
        return r(r(1000 * num) / 10) / 100;
    }
}

/******************************/
/******* PLUGIN $vistra *******/
/******************************/


import notify from 'devextreme/ui/notify';
import Query from 'devextreme/data/query';
import {
    confirm,
    alert,
    custom
} from 'devextreme/ui/dialog'
import localization from './Localization.js'
import { Tipos } from './Tipos.js'
import { ExecucaoFontesDados } from './ExecucaoFontesDados'
import funcoesMatematicas from './FuncoesMatematicas'
import mergeObjects from './mergeObjects';
import { NumberFormat } from './format/NumberFormat'
import { DateFormat } from './format/DateFormat'
import { Estilos } from './Estilos'
import dom2 from './dom2'
import objetos from './objetos'
import expression from './expression'
import { currentTheme, refreshTheme } from "devextreme/viz/themes";
import config from 'devextreme/core/config';
import Components from './Components'
import Painel from './Painel'
import MobileDetect from 'mobile-detect'
import Ajuda from './ajuda'
import Variaveis from './Variaveis'
//import VueGoogleMap from '@/components/mapa'
import VueGoogleMap from 'vue-google-maps-community-fork'
import SignalRUsuariosConectados from "@/funcoes/SignalRUsuariosConectados"
import hideToasts from 'devextreme/ui/toast/hide_toasts';
import UsarContexto from '@/funcoes/Contexto'
import ServiceHealthChecker from "@/funcoes/ServiceHealthChecker";


const DCPlugin = {
    install: (app) => {
        const store = app.config.globalProperties.$store
        const Componentes = Components(app)
        const Painel1 = Painel(app, store)
        const Variaveis1 = Variaveis(app)
        const SignalRUsuariosConectados1 = SignalRUsuariosConectados(app)
        const Contexto1 = UsarContexto(store)
        app.config.globalProperties.$vistra = {
            Components: Componentes,
            Variaveis: Variaveis1,
            indexedDB: window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB,
            chaveGoogleMaps: "",
            SignalRUsuariosConectados: SignalRUsuariosConectados1,            
            Contexto: Contexto1,
            documentTitle: '',
            async carregaMoeda() {
                let response = await app.config.globalProperties.$http.get("/Sistema/GetMoeda")
                config({ defaultCurrency: response.data });
            },
            carregaInfoReport() {
                app.config.globalProperties.$http.get('/sistema/GetInfoReport')
                    .then(response => {
                        store.dispatch("setInfoReport", response.data);
                    })
                    .catch(e => {
                        console.log(e)
                    })
            },
            carregaInfoVistraIA() {
                app.config.globalProperties.$http.get('/sistema/GetInfoVistraIA')
                    .then(response => {
                        store.dispatch("setInfoVistraIA", response.data);
                    })
                    .catch(e => {
                        console.log(e)
                    })
            },
            async onServiceHealthChecker() {
                const _serviceHealthChecker = new ServiceHealthChecker(app);
                try {
                    const responseServiceReport = await _serviceHealthChecker.isServiceUp('/Health/Report');
                    if (!responseServiceReport?.msgErro && responseServiceReport != '') {
                        store.dispatch("setStateServiceIsUpReport", true);
                    }
                    else {
                        store.dispatch("setStateServiceIsUpReport", false);
                    }
                  } catch (error) {
                    store.dispatch("setStateServiceIsUpReport", false);
                  }
            },
            async getConfiguracoesGeralServicos(){
                app.config.globalProperties.$http.get('/Configuracoes/GetGeral')
                    .then(response => {
                        store.dispatch("setConfiguracaoGeralServicos", response.data.servicos);
                    })
                    .catch(e => {
                        console.log(e)
                    })
            },
            
            carregaInfoSistema() {
                app.config.globalProperties.$http.get('/sistema/GetInfo')
                .then(response => {
                    this.documentTitle = response.data.nome;
                    let versaoSalva = this.Contexto.getLocalStorageItem("versaoSistema")
                    store.dispatch("setSistema", response.data)
                    if (store.getters.sistema.versao !== versaoSalva) {
                        console.skull("versão anterior", versaoSalva, "versão nova", store.getters.sistema.versao)
                    }
                    if (store.getters.sistema.pesquisaNPS && store.getters.isLoggedIn)
                        this.pesquisaNPS()
                })
                .catch(e => {
                    console.log(e)
                })
            },
            async carregaLinkChangeLogs() {
                try {
                    const response = await app.config.globalProperties.$http.get('/sistema/GetUsuarioNotificacaoChangeLogs');
                    if(!!response.data){
                        const listagemChangeLog = response.data
                        store.dispatch("setLinkChangeLogs", listagemChangeLog);
                    }
                }
                catch (e) {
                    console.log("Erro ao tentar buscar changelogs do usuário");
                }
            },

            refreshToken() {
                app.config.globalProperties.$http.post('/Usuario/RefreshToken')
            },

            async pesquisaNPS() {

                await this.carregaGoogleMap()
                let empresa = store.getters.empresas.find(e => e.id == store.getters.idEmpresa)
                var a = {
                    key: "71cc3fe0a1e7ecea",
                    campaign: "779aa252",
                    name: store.getters.usuario.nome,
                    email: store.getters.usuario.email,
                    identification: store.getters.usuario.id,
                    tags: {
                        "Nome da Conta": empresa.nome,
                        "Linha Produto": 'VistraBI',
                        "Estado": empresa.estado ?? 'NÃO INFORMADO',
                        "Cidade": empresa.cidade ?? 'NÃO INFORMADO'
                    },
                    salute: this.globalize('nps-salute', store.getters.usuario.nome.split(' ')[0]),
                    thanks: this.globalize('nps-thanks', store.getters.usuario.nome.split(' ')[0])
                };

                (function (f, b, g, a) {
                    var e;
                    var c = f.getElementsByTagName(b)[0];
                    if (f.getElementById(g)) { return }
                    e = f.createElement(b);
                    e.id = g;
                    e.src = "https://cdn.tracksale.co/tracksale-js/tracksale.js";
                    e.type = "text/javascript";
                    e.async = true;
                    e.onload = e.onreadystatechange = async function () {
                        var h = this.readyState;
                        if (h && h != "complete" && h != "loaded") { return }
                        try {
                            let d = new Tracksale();
                            console.show("pesquisa:", a)
                            d.init(a)
                        } catch (i) { }
                    };
                    c.parentNode.insertBefore(e, c)
                }(document, "script", "tracksale-js", a));
            },

            async carregaEmpresas() {
                try {
                    let response = await app.config.globalProperties.$http.get("/Empresa/GetEmpresas")
                    store.dispatch("empresas", JSON.stringify(response.data))
                }
                catch {
                    store.dispatch("empresas", "[]");
                }
            },

            getBytesFromStringBase64(string) {
                var binaryString = window.atob(string);
                var binaryLen = binaryString.length;
                var bytes = new Uint8Array(binaryLen);
                for (var i = 0; i < binaryLen; i++) {
                    var ascii = binaryString.charCodeAt(i);
                    bytes[i] = ascii;
                }
                return bytes;
            },

            removePropriedadesNulas(objeto) {
                if (!objeto)
                    return objeto;
                let obj = JSON.parse(JSON.stringify(objeto));
                Object.keys(obj).forEach(key => obj[key] == null && delete obj[key]);
                return obj;
            },

            downloadBytes(bytes, tipo, nomeArquivo) {
                var blob = new Blob([bytes], { type: tipo });
                this.downloadBlob(blob, nomeArquivo, tipo)
            },

            downloadBlob(blob, nomeArquivo, tipo = null) {
                var link = document.createElement('a')
                link.href = URL.createObjectURL(blob)
                link.download = `${nomeArquivo}`
                if (tipo == 'application/zip')
                    link.download += ".zip"
                document.body.appendChild(link)
                link.click()
                window.setTimeout(function () {
                    URL.revokeObjectURL(blob)
                    document.body.removeChild(link)
                }, 100);
            },

            async carregaGoogleMap() {
                return new Promise(async (resolve) => {
                    let response = await app.config.globalProperties.$http.get('/sistema/GetChaveGoogleMaps')
                    this.chaveGoogleMaps = response.data
                    app.use(VueGoogleMap, {
                        load: {
                            key: response.data,
                            //Ele é atualizado uma vez por semana e é o mais atual.
                            v: "weekly",
                            libraries: 'visualization',
                        }
                    })
                    app.$gmapApiPromiseLazy().then(resolve(true))
                })
            },

            boxesUsandoVariavel(nomeVariavel, boxes) {
                return boxes.filter(box => {
                    switch (box.type) {
                        case 'DBText':
                            return (box.componentObj.dados.texto || '').includes(this.getHTMLMention(nomeVariavel))
                        case 'TreeMap':
                            return (box.objeto().option('title').fakeText?.text || '').includes(this.getHTMLMention(nomeVariavel))
                        case 'GaugeLinear':
                        case 'GaugeCircular':
                            return (box.objeto().option('scale.valorFinal.origem') == 'variavel' && box.objeto().option('scale.valorFinal.origemVariavel') == nomeVariavel) ||
                                (box.objeto().option('subValores.origem') == 'variavel' && box.objeto().option('subValores.variavel') == nomeVariavel)
                        case 'FilterDropDown':
                        case 'FilterTextBox':
                        case 'FilterList':
                            return (box.componentObj.dados.config.valorInicial.origem == 'variavel' && box.componentObj.dados.config.valorInicial.variavel == nomeVariavel)
                        case 'GaugeBullet':
                            return ((this.box?.bulletInfo?.variaveValor == nomeVariavel) ||
                                (!this.box?.bulletInfo?.valorFixoMeta && this.box?.bulletInfo?.variaveMeta == nomeVariavel))
                    }
                    return box.type !== 'Card' && this.tituloUsaVariavel(nomeVariavel, box)
                });
            },

            formatacaoCondicionalUsaVariavel(nomeVariavel, box) {
                // varre todas as condições de formatação condicional de todos os objetos pra ver se a variável é usada

                const encontraVariavel = (filtroP) => {
                    if (!filtroP)
                        return false
                    let filtro = [...filtroP]
                    for (let index = 0; index < filtro.length; index++) {
                        if (Array.isArray(filtro[index])) {
                            return encontraVariavel(filtro[index]);
                        } else if (index == 0 && filtro[index].match(new RegExp(`.*\.variavelDoPainel`, 'g')) && filtro[2] == nomeVariavel) {
                            return true
                        }
                    }
                    return false
                }

                switch (box.type) {
                    case 'DBText':
                        return (box.componentObj.dados.formatacaoCondicional || []).some(f => encontraVariavel(f.valor?.filtroExec || []))
                    case 'Mapa':
                        return box.componentObj.dados.camadas.some(c => (c.formatacaoCondicional || []).some(f => encontraVariavel(f.valor?.filtroExec || [])))
                    default:
                        return (box.objeto().option('formatacaoCondicional') || []).some(f => encontraVariavel(f.valor?.filtroExec || []))
                }
            },

            tituloUsaVariavel(nomeVariavel, box) {
                const findProp = (prop) => {
                    let texto = box.objeto().option(prop)
                    return !!texto && texto.includes(this.getHTMLMention(nomeVariavel))
                }
                return box.componentObj?.propriedadesQuePodemTerVariaveis.some(propriedade => {
                    let prop = propriedade.fakeProp || propriedade.prop
                    if (prop.includes('[x]')) {
                        let propArray = box.objeto().option(prop.split('[x]')[0]) || []
                        return propArray.some((pa, index) => findProp(prop.replace('[x]', `[${index}]`)))
                    }
                    return findProp(prop)
                });
            },

            getFormatacaoDev(objeto) {
                if (!objeto || objeto.type == undefined)
                    return null
                let format = JSON.parse(JSON.stringify(objeto)) //não passa a referência pq o objeto pode ser alterado depois alterando o original
                if (format?.type && format.type.startsWith("n_")) {
                    return (value) => {
                        let negativo = value < 0;
                        value = Math.abs(Math.trunc(value))
                        let horas = String(Math.trunc(value / 3600)).padStart(2, "0")
                        if (format.type == 'n_hour')
                            return `${negativo ? "-" : ""}${horas}`
                        let minutos = String(Math.trunc(((value % 3600) / 60))).padStart(2, "0");
                        if (format.type == 'n_minute')
                            return `${negativo ? "-" : ""}${minutos}`
                        let segundos = String(value - ((horas * 3600) + (minutos * 60))).padStart(2, "0");
                        if (format.type == 'n_shortTime')
                            return `${negativo ? "-" : ""}${horas}:${minutos}`
                        return `${negativo ? "-" : ""}${horas}:${minutos}:${segundos}`
                    }
                }
                return format;
            },

            mentionSymbol() {
                return '%'
            },

            getHTMLMention(nome) {
                return `${this.mentionSymbol()}${nome}${this.mentionSymbol()}`
            },
            modificaBetween(value) {
                if (value == undefined)
                    return value
                let array = Array.isArray(value) ? [...value] : JSON.parse(value);
                let idx = 0;
                while (idx < array.length) {
                    let element = array[idx];
                    if (Array.isArray(element)) {
                        if (element[1] == 'between') {
                            let aux1 = [element[0], '>=', element[2][0]];
                            let aux2 = [element[0], '<=', element[2][1]];
                            array[idx] = [aux1, 'and', aux2];
                            idx++; // move to the next element
                        } else {
                            array[idx] = this.modificaBetween(element);
                        }
                    } else if (element == 'between') {
                        let aux1 = [array[0], '>=', array[2][0]];
                        let aux2 = [array[0], '<=', array[2][1]];
                        array = [aux1, 'and', aux2];
                        break;
                    }
                    idx++; // move to the next element
                }
                return array;
            },
            //  CASO HAJA A NECESSIDADE DE COMPARAR OBJETOS PARA VERIFICAR SE HA ALTERAÇÕES
            //  BASTA PASSAR OS 2 OBJETOS PARA COMPARAR ELE IRA COMPARAR ATE O MAIS PROFUNDO NIVEL DE ANINHAÇÃO DE ARRAY
            compareObjects (obj1, obj2){
                const changes = {};

                function isObject(value) {
                    return value && typeof value === 'object' && !Array.isArray(value);
                }

                function findChanges(key, value1, value2) {
                    if (isObject(value1) && isObject(value2)) {
                        const nestedChanges = this.compareObjects(value1, value2);
                        if (Object.keys(nestedChanges).length > 0) {
                            changes[key] = nestedChanges;
                        }
                    } else if (value1 !== value2) {
                        changes[key] = { before: value1, after: value2 };
                    }
                }

                const keys1 = Object.keys(obj1);
                const keys2 = Object.keys(obj2);
                const allKeys = new Set([...keys1, ...keys2]);

                allKeys.forEach(key => {
                    findChanges(key, obj1[key], obj2[key]);
                });

                return changes;
            },

            decodeHTML(str) {
                var element = document.createElement('div');

                if (str && typeof str === 'string') {
                    // strip script/html tags
                    str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
                    str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
                    element.innerHTML = str;
                    str = element.textContent;
                    element.textContent = '';
                }

                return str;
            },
            classeModoEscuro() {
                //return `dx-swatch-${window.tema}-dark`;
                return `dx-swatch-vistra-dark`;
            },

            estaNoModoEscuro() {
                return document.querySelector('#app')?.classList?.contains(this.classeModoEscuro())
            },

            alternarLayout(option) {
                if (!option)
                    return

                const painelContainer = document.querySelector('.painel-container-centro')
                if (!painelContainer)
                    return
                const canvas = painelContainer.querySelector('.dx-scrollable')
                const scrollableContent = painelContainer.querySelector('.dx-scrollable-content')

                scrollableContent.style.paddingRight = 0;
                switch (option.type) {
                    case 'desktop':
                        canvas.style.width = '100%'
                        canvas.style.maxWidth = 'unset'
                        canvas.style.minWidth = '650px'
                        canvas.style.maxHeight = 'unset'

                        break;

                    case 'mobile':
                        painelContainer.style.justifyContent = 'center'
                        canvas.style.maxWidth = '400px'
                        canvas.style.minWidth = '0px'
                        canvas.style.maxHeight = '700px'
                        break;

                    case 'tablet':
                        painelContainer.style.justifyContent = 'center'
                        canvas.style.maxWidth = '768px'
                        canvas.style.minWidth = '650px'
                        canvas.style.maxHeight = '1024px'
                        break;
                    case 'widget':
                        painelContainer.style.justifyContent = 'center'
                        if (option.larguraMinima) {
                            canvas.style.maxWidth = `${option.larguraMinima}px`
                            canvas.style.minWidth = '0%'
                        } else {
                            canvas.style.maxWidth = `${(368 + (416 * (option.colunas - 1)))}px`
                            canvas.style.minWidth = '33%'
                        }
                        canvas.style.maxHeight = `280px`

                        break;
                    default:
                        break;
                }
            },

            alternaModoEscuro(callback) {
                document.querySelector('#app').classList.toggle(this.classeModoEscuro());
                document.querySelector('.page-body').classList.toggle(this.classeModoEscuro());

                const html = document.querySelector("html");

                //setTimeout(() => {                    
                if (this.estaNoModoEscuro()) {
                    console.show('Ativando modo escuro');
                    currentTheme("material.blue.dark");
                }
                else {
                    console.show('Ativando modo claro');
                    currentTheme("material.blue.light");
                }
                refreshTheme();

                if (callback)
                    callback();

                if (html) {
                    if (!html.classList.contains("dark"))
                        html.classList.add("dark");

                    else if (html.classList.contains("dark"))
                        html.classList.remove("dark");
                }

                //}, 100);
            },

            lowestUnusedNumber(sequence, startingFrom) {
                sequence.sort(function (a, b) { return a - b; });

                var lowest = -1;
                for (let i = 0; i < sequence.length; ++i) {
                    if (sequence[i] != startingFrom) {
                        lowest = startingFrom;
                        break;
                    }
                    ++startingFrom;
                }
                if (lowest == -1)
                    lowest = sequence[sequence.length - 1] + 1;

                return lowest;
            },

            getNomeNovoObjeto(boxesDoMesmoTipo, nomePadrao) {
                let arrayDeNumerosUsados = [];
                boxesDoMesmoTipo.forEach(box => {
                    var finalDaString = (box.name || "").replace(nomePadrao, "");
                    if (finalDaString.length > 0) {
                        var numeroUsado = parseInt(finalDaString);
                        if (typeof numeroUsado == "number")
                            arrayDeNumerosUsados.push(numeroUsado);
                    }
                });
                return nomePadrao += arrayDeNumerosUsados.length > 0
                    ? this.lowestUnusedNumber(arrayDeNumerosUsados, 1)
                    : 1;
            },

            mensagensAtivas: [],

            showMessage(msg, type, opcoes, ignoraIntegracao = false) {

                //CASO SEJA UMA INTEGRAÇÃO
                if (store.getters.integracao && !ignoraIntegracao) {
                    //se for integração não dá mensagem ao usuário, somente no console pra eventual debug, porém há casos como em requisição API aonde precisa ser mostrado uma mensagem para o usuario tarefa #122007
                    switch (type) {
                        case "error":
                            return console.error(msg)
                        case "warning":
                            return console.warn(msg)
                    }
                    return console.info(msg)
                }
                //PARA NÃO REPETIR A NOTIFICAÇÃO
                this.mensagensAtivas = [...this.mensagensAtivas.filter(ma => ma.expiracao > (new Date()))]
                if (this.mensagensAtivas.find(ma => ma.msg === msg)) {
                    //serve pra não aparecer a mesma mensagem se já estiver ativa
                    return
                }
                if (type == undefined)
                    type = "success"

                let timeOut = (opcoes || {}).displayTime || (type == "error" ? 5000000 : (type == "warning" ? 5000 : 2000))
                let novaMsg = {
                    expiracao: new Date((new Date()).getTime() + timeOut),
                    msg
                }
                this.mensagensAtivas.push(novaMsg)

                var options = {
                    message: msg,
                    minWidth: 300,
                    width: 'auto',
                    hideOnOutsideClick: true,
                    position: {
                        my: "right top", at: "right top", of: "#app", offset: "-16 16"
                    },
                    contentTemplate: `<i class="ml-auto dx-toast-icon-close dx-icon-close cursor-pointer" id="btnFecharToast"></i>`,
                    onHidden: () => {
                        this.mensagensAtivas = this.mensagensAtivas.filter(ma => ma.msg !== msg)
                    }
                }

                //Template HTML
                if (opcoes && opcoes.template) {
                    options.contentTemplate = msg + `<i class="ml-auto dx-toast-icon-close dx-icon-close cursor-pointer" id="btnFecharToast"></i>`
                    options.message = ''
                    
                    if(opcoes.templateLogin){
                        options.contentTemplate = `
                            <i class="fa-light fa-circle-xmark fa-xl"></i>
                            <div class="flex flex-col p-4">
                                <h6 class="mb-2" >Usuário ou senha incorreta!</h6>
                                <label>Tente novamente ou redefina sua senha clicando em “Esqueceu sua senha?”.</label>
                            </div>
                            <i class="ml-auto dx-toast-icon-close dx-icon-close cursor-pointer" id="btnFecharToast"></i>
                        `
                        options.message = ''
                    }
                }

                if (type == 'error') {
                    console.error(msg)
                    //console.trace()
                }
                
                if(opcoes && opcoes.minWidth){
                    options.minWidth = opcoes.minWidth;
                }
                
                if(opcoes && opcoes.width){
                    options.width = opcoes.width;
                }

                notify(options, type, timeOut)

                let btnFecharToast = document.getElementById('btnFecharToast');
                btnFecharToast.addEventListener('click', event => {
                    hideToasts();
                })
            },
            showMessageConfirmacao(msg, titulo, callbackSim, callbackNao, callbackEsc) {
                /*
                var c = custom({
                    message: msg,
                    showTitle: true,
                    title: titulo,
                    buttons: [{
                        text: this.globalize('Yes'),
                        onClick: callbackSim
                    },
                    {
                        text: this.globalize('No'),
                        onClick: callbackNao
                    }]
                });
                c.show();
                */
                var c = confirm(msg, titulo)
                    .done(function (dialogResult) {
                        if (dialogResult) {
                            if (callbackSim)
                                callbackSim();
                        } else
                            if (callbackNao)
                                callbackNao();
                    })
                    .catch((e) => {
                        if (callbackEsc)
                            callbackEsc();
                    })
            },

            exibeMensagemSistema() {

                const MINUTOS_ENTRE_MENSAGENS = 60;

                setTimeout(() => {
                    try {
                        if (getsessionStorageItem('msgSistema')) {

                            if (!sessionStorage.getItem('msgSistemaUltima') || //se nao tem uma ultima mensagem storada, exibe
                                !sessionStorage.getItem('msgSistemaProximaExibicao') || //se nao tem nenhuma proxima exibcao storada, exibe
                                sessionStorage.getItem('msgSistema') != sessionStorage.getItem('msgSistemaUltima') || //se a mensagem atual é diferente da ultima storada, exibe
                                (new Date()).getTime() > (new Date(sessionStorage.getItem('msgSistemaProximaExibicao'))).getTime() //se a data atual é menor que a data da proxima exibicao storada, exibe
                            ) {
                                clearTimeout(this.timer);
                                this.showMessage(sessionStorage.getItem('msgSistema'), "info", { displayTime: 4000 });
                                sessionStorage.setItem('msgSistemaUltima', sessionStorage.getItem('msgSistema'))
                                sessionStorage.setItem('msgSistemaProximaExibicao', this.addMinutes(MINUTOS_ENTRE_MENSAGENS));
                                sessionStorage.removeItem('msgSistema');
                                console.show('# SYS: Mensagem do sistema exibida');
                            } else {
                                let timerExibicao = new Date(sessionStorage.getItem('msgSistemaProximaExibicao')) - new Date();
                                if (timerExibicao > 0) {
                                    console.show('# SYS: Timer ativado', timerExibicao);
                                    this.timer = setTimeout(() => {
                                        console.show('# SYS: Mensagem do sistema exibida pelo timer');
                                        this.exibeMensagemSistema();
                                    }, timerExibicao);
                                }
                            }
                        }
                    } catch {}
                }, 1500)
            },

            showMessageConfirmacaoCancela(msg, titulo, callbackSim, callbackNao, callbackCancela) {

                var c = custom({
                    message: msg,
                    showTitle: true,
                    title: titulo,
                    buttons: [{
                        text: this.globalize('Yes'),
                        onClick: callbackSim
                    },
                    {
                        text: this.globalize('No'),
                        onClick: callbackNao
                    },
                    {
                        text: this.globalize('Cancel'),
                        onClick: callbackCancela
                    }
                    ]
                });
                c.show();
            },

            showMessageConfirmacaoAsync(msg, titulo) {
                return new Promise((resolve) => {
                    var c = confirm(msg, titulo).done(function (dialogResult) {
                        resolve(dialogResult)
                    });
                })
            },

            alert(msg, titulo) {
                return new Promise((resolve) => {
                    alert(msg, titulo).done(() => {
                        resolve()
                    });
                })
            },

            // customAlert(msg, titulo, botoes) {
            //     return new Promise((resolve) => {
            //         custom({ message: msg, title: titulo, buttons: botoes }).show().done(() => {
            //             resolve()
            //         });
            //     })
            // },
            customAlert(msg, titulo, botoes) {
                return custom({ message: msg, title: titulo, buttons: botoes })
            },

            popupAnimation: {
                // show: {
                //     type: "fade",
                //     duration: 500,
                //     from: 0,
                //     to: 1
                // },
                //show: { type: 'pop', duration: 500, from: { scale: 0.8 } }
            },

            getTempo(milisegundos, opcoes) {
                var op = {
                    hora: (opcoes && opcoes.hora != undefined) ? opcoes.hora : true,
                    minuto: (opcoes && opcoes.minuto != undefined) ? opcoes.minuto : true,
                    segundo: (opcoes && opcoes.segundo != undefined) ? opcoes.segundo : true,
                    milisegundo: (opcoes && opcoes.milisegundo != undefined) ? opcoes.milisegundo : false
                }
                let pad = (n, z = 2) => ('00' + n).slice(-z)
                let tempoExecutando = ""
                if (op.hora)
                    tempoExecutando = pad(milisegundos / 3.6e6 | 0)
                if (op.minuto)
                    tempoExecutando += ((tempoExecutando == "") ? "" : ":") + pad((milisegundos % 3.6e6) / 6e4 | 0)
                if (op.segundo)
                    tempoExecutando += ((tempoExecutando == "") ? "" : ":") + pad((milisegundos % 6e4) / 1000 | 0)
                if (op.milisegundo)
                    tempoExecutando += ((tempoExecutando == "") ? "" : ".") + pad(milisegundos % 1000, 3)
                return tempoExecutando
            },

            randomStr(size) {
                size = size || max;
                let base = Math.random().toString().replace('.', '') + Math.random().toString().replace('.', '');
                while (base.length < size)
                    base += Math.random().toString().replace('.', '');
                base = base.split('').map(function (t) { return [Math.random(), t]; }).sort().map(function (t) { return t[1]; }).join('');
                //console.log(base);
                return btoa(base).split('=').join('').substr(0, size);
            },

            randomInt(maximo) {
                return Math.floor(Math.random() * (maximo || 1000000000))
            },

            isValidDate(date) {
                if (date.length > 10)
                    date = date.substring(0, 10)
                let temp = date?.split('/');
                //var d = new Date(temp[1] + '/' + temp[0] + '/' + temp[2]);
                //return (d && (d.getMonth() + 1) == Number(temp[1]) && d.getDate() == Number(temp[0]) && d.getFullYear() == Number(temp[2]));
                var d = new Date(temp[0] + '/' + temp[1] + '/' + temp[2]);
                return (d.toLocaleDateString() === date);
            },

            getDate_yyyyMMdd(date) {
                if (date.length < 10)
                    return date
                if (date.length > 10)
                    date = date.substring(0, 10)
                let temp = date.split('/');
                return `${temp[2]}-${temp[1]}-${temp[0]}`
            },

            getDate_MMddyyyy(date) {
                if (date.length < 10)
                    return date
                if (date.length > 10)
                    date = date.substring(0, 10)
                let temp = date.split('/');
                return `${temp[1]}/${temp[0]}/${temp[2]}`
            },

            StringToDate(date, padrao) {
                try {
                    if (typeof (date) == "Date")
                        return date
                    if (date.length > 10)
                        date = date.substring(0, 10)
                    if (this.isValidDate(date)) {
                        return new Date(date);
                    }
                    return padrao || null
                } catch (e) {
                    return padrao || null
                }
            },

            /**
             * @param {number} número de dias a adicionar (negativo para datas retroativas)
             * @param {datetime} data (data ou gettime) se não for informada, pegará a atual
             */
            addDays(days, date) {
                date = date ? (date.constructor.name == 'Number' ? date : date.getTime()) : Date.now();
                return new Date(date + days * 24 * 60 * 60 * 1000);
            },

            /**
             * @param {number} número de horas a adicionar (negativo para datas retroativas)
             * @param {datetime} data (data ou gettime) se não for informada, pegará a atual
             */
            addHours(hours, date) {
                date = date ? (date.constructor.name == 'Number' ? date : date.getTime()) : Date.now();
                return new Date(hours + hours * 60 * 60 * 1000);
            },

            /**
             * @param {number} número de minutos a adicionar (negativo para datas retroativas)
             * @param {datetime} data (data ou gettime) se não for informada, pegará a atual
             */
            addMinutes(minutes, date) {
                date = date ? (date.constructor.name == 'Number' ? date : date.getTime()) : Date.now();
                return new Date(date + minutes * 60 * 1000);
            },

            /**
             * @param {number} número de segundos a adicionar (negativo para datas retroativas)
             * @param {datetime} data (data ou gettime) se não for informada, pegará a atual
             */
            addSeconds(seconds, date) {
                date = date ? (date.constructor.name == 'Number' ? date : date.getTime()) : Date.now();
                return new Date(date + seconds * 1000);
            },

            daysBetween(one, another) {
                var d1 = (new Date(one)).setHours(0, 0, 0, 0); //ignore time part
                var d2 = (new Date(another)).setHours(0, 0, 0, 0); //ignore time part
                return Math.round(Math.abs(d1 - d2) / 8.64e7);
            },

            /**
             * @param {datetime} data
             * @param {string} formato Formato da data (padrão "dd/MM/yyyy")
             */
            DateToString(data, formato) {
                if (typeof data === "string") {
                    try {
                        data = new Date(data)
                    }
                    catch {
                        data = ""
                    }
                }

                if (!data)
                    return ""
                formato = formato || "dd/MM/yyyy"
                var dia = data.getDate().toString().padStart(2, '0'),
                    mes = (data.getMonth() + 1).toString().padStart(2, '0'), //+1 pois no getMonth Janeiro começa com zero.
                    ano = data.getFullYear();

                return formato.replace("yyyy", ano).replace("MM", mes).replace("dd", dia)
                //return dia + "/" + mes + "/" + ano;
            },

            dateTimeReviver: function (key, value) {
                var a;
                if (typeof value === 'string') {
                    a = /\/Date\((\d*)\)\//.exec(value);
                    if (a) {
                        return new Date(+a[1]);
                    }
                }
                return value;
            },

            ICONE_SALVAR: "far fa-save",
            ICONE_RECARREGAR: "icones/refresh.svg",
            ICONE_EXCLUIR: "trash",
            ICONE_ALTERAR: "edit",
            ICONE_CONFIRMAR: "check",
            ICONE_CANCELAR: "revert",
            ICONE_ACIMA: "chevronup",
            ICONE_ABAIXO: "chevrondown",
            ICONE_ESQUERDA: "chevronleft",
            ICONE_DIREITA: "chevronright",
            ICONE_CLONAR: "fal fa-clone",
            ICONE_FUNCAO: "icones/campo_funcao.svg",
            ICONE_INFO: "fas fa-info",

            dblclick(e, funcaoCallback) {
                var component = e.component;

                function initialClick() {
                    component.clickCount = 1;
                    component.clickKey = e.key;
                    component.clickDate = new Date();
                }

                function doubleClick() {
                    component.clickCount = 0;
                    component.clickKey = 0;
                    component.clickDate = null;

                    if (funcaoCallback)
                        funcaoCallback();
                }

                if ((!component.clickCount) || (component.clickCount != 1) || (component.clickKey != e.key)) {
                    initialClick();
                } else if (component.clickKey == e.key) {
                    if (((new Date()) - component.clickDate) <= 300)
                        doubleClick();
                    else
                        initialClick();
                }
            },

            dblclickEdicao(e) {
                this.dblclick(e, function () {
                    e.component.editRow(e.component.getRowIndexByKey(e.key));
                });
            },

            getRepeticao(caracter, repeticoes) {
                var result = "";
                for (var i = 0; i < repeticoes; i++)
                    result += caracter;
                return result;
            },

            copyObject(obj) {
                var copy = {};
                for (var item in obj)
                    if (obj.hasOwnProperty(item))
                        copy[item] = obj[item];
                return copy;
            },

            round2(num) {
                num = typeof num == "string" ? parseInt(num) : num
                return Math.round((num + Number.EPSILON) * 100) / 100;
            },

            //console.log identado por profundidade
            log(...data) {
                console.show(' '.repeat(new Error().stack.match(/\n/g).length - 2), ...data)
            },

            randomColor() {
                return '#' + Math.floor(Math.random() * 16777215).toString(16);
            },

            hex2rgba(hex, alpha) {
                hex = hex.slice(1)
                const change = val => parseInt(val, 16) || 0
                const rgba = {
                    r: change(hex.slice(0, 2)),
                    g: change(hex.slice(2, 4)),
                    b: change(hex.slice(4, 6)),
                    a: alpha
                }
                return `rgba(${[rgba.r, rgba.g, rgba.b, rgba.a].join(',')})`
            },

            rgbText2hex(rgb, toUpper) {
                const change = val => ('0' + Number(val).toString(16)).slice(-2)
                const matchColors = /rgb\((\d{1,3}), (\d{1,3}), (\d{1,3})\)/;
                var match = matchColors.exec(rgb);
                let r = match[1], g = match[2], b = match[3];
                const color = `#${change(r)}${change(g)}${change(b)}`
                return toUpper ? color.toUpperCase() : color
            },

            associaPermissoes(objeto1, objeto2) {
                for (let op in objeto1) {
                    if (objeto2[op] == 1)
                        objeto1[op] = true
                    else if (objeto2[op] == 2)
                        objeto1[op] = false
                }
            },

            temPermissao(comando, permissao) {
                return new Promise((resolve) => {
                    app.config.globalProperties.$http.get(comando, {}).then(response => {
                        let permissoes = {
                            [permissao]: false
                        }
                        this.associaPermissoes(permissoes, response.data)
                        resolve(permissoes[permissao])
                    }).catch(erro => {
                        resolve(false)
                    })
                })
            },

            retiraAcentos(text) {
                if (text == undefined)
                    return text;
                const a = 'ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝŔÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿŕ'
                const b = 'AAAAAAACEEEEIIIIDNOOOOOOUUUUYRsBaaaaaaaceeeeiiiionoooooouuuuybyr'
                const p = new RegExp(a.split('').join('|'), 'g')
                return text.toString().replace(p, c => b.charAt(a.indexOf(c)))
            },

            removeQuebraPagina(text, separator = " ") {
                if (text == null)
                    return null;

                text = text.replace(/\r\n/g, separator);
                text = text.replace(/\r/g, "");
                text = text.replace(/\n/g, separator);
                return text;
            },

            removeCaracterEspecial(text, removeEspacos = false, removeAcentos = true, removeQuebraPagina = false, trim = false, exceptions = "", trocarEspacosPorUnderline = false) {
                let ret = text;

                if (ret == null || ret === "")
                    return ret;

                if (removeAcentos)
                    ret = this.retiraAcentos(ret);

                ret = ret.replace(/\t/g, " ");

                if (!removeEspacos)
                    ret = ret.replace(new RegExp(`[^0-9a-zA-ZéúíóáÉÚÍÓÁèùìòàÈÙÌÒÀõãñÕÃÑêûîôâÊÛÎÔÂëÿüïöäËYÜÏÖÄçÇ\\s${exceptions}]+?`, "g"), "");
                else if (removeEspacos && trocarEspacosPorUnderline)
                    ret = ret.replace(new RegExp(`[^0-9a-zA-ZéúíóáÉÚÍÓÁèùìòàÈÙÌÒÀõãñÕÃÑêûîôâÊÛÎÔÂëÿüïöäËYÜÏÖÄçÇ\\s_${exceptions}]+?`, "g"), "").replace(/\s+/g, "_");
                else
                    ret = ret.replace(new RegExp(`[^0-9a-zA-ZéúíóáÉÚÍÓÁèùìòàÈÙÌÒÀõãñÕÃÑêûîôâÊÛÎÔÂëÿüïöäËYÜÏÖÄçÇ${exceptions}]+?`, "g"), "");
                
                if (removeQuebraPagina)
                    ret = this.removeQuebraPagina(ret);

                if (trim)
                    ret = ret.trim();

                ret = ret.replace(/ {2}/g, " ");

                return ret;
            },

            getMatches(string, regex, index) {
                index || (index = 1); // default to the first capturing group
                var matches = [];
                var match;
                while (match = regex.exec(string)) {
                    matches.push(match[index]);
                }
                return matches;
            },

            iconesConexoes: [
                { sgbd: "MYSQL", icone: "/assets/bancos/mysql.svg" },
                { sgbd: "SQLSERVER", icone: "/assets/bancos/sqlserver.svg" },
                { sgbd: "POSTGRES", icone: "/assets/bancos/postgresql.svg" },
                { sgbd: "FIREBIRD", icone: "/assets/bancos/firebird.png" },
                { sgbd: "ORACLE", icone: "/assets/bancos/oracle.png" },
                { sgbd: "DB2", icone: "/assets/bancos/db2.png" },
                { sgbd: "ANYWHERE", icone: "/assets/bancos/ianywhere.png" },
                { sgbd: "PADRAO", icone: "/assets/bancos/padrao.svg" },
                { sgbd: "BIGQUERY", icone: "/assets/bancos/bigquery.svg" }
            ],

            ordenarPor(array, propriedade, crescente = true) {
                if (crescente)
                    return array.sort((a, b) => {
                        return (a[propriedade] > b[propriedade]) ? 1 : ((a[propriedade] < b[propriedade]) ? -1 : 0);
                    });
                else
                    return array.sort((a, b) => {
                        return (a[propriedade] > b[propriedade]) ? -1 : ((a[propriedade] < b[propriedade]) ? 1 : 0);
                    });
            },

            randomIntFromInterval(min, max) // min and max included
            {
                return Math.floor(Math.random() * (max - min + 1) + min);
            },

            getBrowserInfo() {
                var geckobrowsers;
                var browser = "";
                var browserVersion = 0;
                var agent = navigator.userAgent + " ";
                if (agent.substring(agent.indexOf("Mozilla/") + 8, agent.indexOf(" ")) == "5.0" && agent.indexOf("like Gecko") != -1) {
                    geckobrowsers = agent.substring(agent.indexOf("like Gecko") + 10).substring(agent.substring(agent.indexOf("like Gecko") + 10).indexOf(") ") + 2).replace("LG Browser", "LGBrowser").replace("360SE", "360SE/");
                    for (let i = 0; i < 1; i++) {
                        geckobrowsers = geckobrowsers.replace(geckobrowsers.substring(geckobrowsers.indexOf("("), geckobrowsers.indexOf(")") + 1), "");
                    }
                    geckobrowsers = geckobrowsers.split(" ");
                    for (let i = 0; i < geckobrowsers.length; i++) {
                        if (geckobrowsers[i].indexOf("/") == -1) geckobrowsers[i] = "Chrome";
                        if (geckobrowsers[i].indexOf("/") != -1) geckobrowsers[i] = geckobrowsers[i].substring(0, geckobrowsers[i].indexOf("/"));
                    }
                    if (geckobrowsers.length < 4) {
                        browser = geckobrowsers[0];
                    } else {
                        for (let i = 0; i < geckobrowsers.length; i++) {
                            if (geckobrowsers[i].indexOf("Chrome") == -1 && geckobrowsers[i].indexOf("Safari") == -1 && geckobrowsers[i].indexOf("Mobile") == -1 && geckobrowsers[i].indexOf("Version") == -1) browser = geckobrowsers[i];
                        }
                    }
                    browserVersion = agent.substring(agent.indexOf(browser) + browser.length + 1, agent.indexOf(browser) + browser.length + 1 + agent.substring(agent.indexOf(browser) + browser.length + 1).indexOf(" "));
                } else if (agent.substring(agent.indexOf("Mozilla/") + 8, agent.indexOf(" ")) == "5.0" && agent.indexOf("Gecko/") != -1) {
                    browser = agent.substring(agent.substring(agent.indexOf("Gecko/") + 6).indexOf(" ") + agent.indexOf("Gecko/") + 6).substring(0, agent.substring(agent.substring(agent.indexOf("Gecko/") + 6).indexOf(" ") + agent.indexOf("Gecko/") + 6).indexOf("/"));
                    browserVersion = agent.substring(agent.indexOf(browser) + browser.length + 1, agent.indexOf(browser) + browser.length + 1 + agent.substring(agent.indexOf(browser) + browser.length + 1).indexOf(" "));
                } else if (agent.substring(agent.indexOf("Mozilla/") + 8, agent.indexOf(" ")) == "5.0" && agent.indexOf("Clecko/") != -1) {
                    browser = agent.substring(agent.substring(agent.indexOf("Clecko/") + 7).indexOf(" ") + agent.indexOf("Clecko/") + 7).substring(0, agent.substring(agent.substring(agent.indexOf("Clecko/") + 7).indexOf(" ") + agent.indexOf("Clecko/") + 7).indexOf("/"));
                    browserVersion = agent.substring(agent.indexOf(browser) + browser.length + 1, agent.indexOf(browser) + browser.length + 1 + agent.substring(agent.indexOf(browser) + browser.length + 1).indexOf(" "));
                } else if (agent.substring(agent.indexOf("Mozilla/") + 8, agent.indexOf(" ")) == "5.0") {
                    browser = agent.substring(agent.indexOf("(") + 1, agent.indexOf(";"));
                    browserVersion = agent.substring(agent.indexOf(browser) + browser.length + 1, agent.indexOf(browser) + browser.length + 1 + agent.substring(agent.indexOf(browser) + browser.length + 1).indexOf(" "));
                } else if (agent.substring(agent.indexOf("Mozilla/") + 8, agent.indexOf(" ")) == "4.0" && agent.indexOf(")") + 1 == agent.length - 1) {
                    browser = agent.substring(agent.indexOf("(") + 1, agent.indexOf(")")).split("; ")[agent.substring(agent.indexOf("(") + 1, agent.indexOf(")")).split("; ").length - 1];
                } else if (agent.substring(agent.indexOf("Mozilla/") + 8, agent.indexOf(" ")) == "4.0" && agent.indexOf(")") + 1 != agent.length - 1) {
                    if (agent.substring(agent.indexOf(") ") + 2).indexOf("/") != -1) browser = agent.substring(agent.indexOf(") ") + 2, agent.indexOf(") ") + 2 + agent.substring(agent.indexOf(") ") + 2).indexOf("/"));
                    if (agent.substring(agent.indexOf(") ") + 2).indexOf("/") == -1) browser = agent.substring(agent.indexOf(") ") + 2, agent.indexOf(") ") + 2 + agent.substring(agent.indexOf(") ") + 2).indexOf(" "));
                    browserVersion = agent.substring(agent.indexOf(browser) + browser.length + 1, agent.indexOf(browser) + browser.length + 1 + agent.substring(agent.indexOf(browser) + browser.length + 1).indexOf(" "));
                } else if (agent.substring(0, 6) == "Opera/") {
                    browser = "Opera";
                    browserVersion = agent.substring(agent.indexOf(browser) + browser.length + 1, agent.indexOf(browser) + browser.length + 1 + agent.substring(agent.indexOf(browser) + browser.length + 1).indexOf(" "));
                    if (agent.substring(agent.indexOf("(") + 1).indexOf(";") != -1) os = agent.substring(agent.indexOf("(") + 1, agent.indexOf("(") + 1 + agent.substring(agent.indexOf("(") + 1).indexOf(";"));
                    if (agent.substring(agent.indexOf("(") + 1).indexOf(";") == -1) os = agent.substring(agent.indexOf("(") + 1, agent.indexOf("(") + 1 + agent.substring(agent.indexOf("(") + 1).indexOf(")"));
                } else if (agent.substring(0, agent.indexOf("/")) != "Mozilla" && agent.substring(0, agent.indexOf("/")) != "Opera") {
                    browser = agent.substring(0, agent.indexOf("/"));
                    browserVersion = agent.substring(agent.indexOf(browser) + browser.length + 1, agent.indexOf(browser) + browser.length + 1 + agent.substring(agent.indexOf(browser) + browser.length + 1).indexOf(" "));
                } else {
                    browser = agent;
                }

                return {
                    navegador: browser,
                    versaoNavegador: (String)(parseInt(browserVersion, 10))
                }
            },

            newGUID() {
                let u = Date.now().toString(16) + Math.random().toString(16) + '0'.repeat(16);
                return [u.substr(0, 8), u.substr(8, 4), '4000-8' + u.substr(13, 3), u.substr(16, 12)].join('-');
            },

            getFuncoesFonteDados(fnDados) {

                let funcoes = {}

                //lista
                funcoes.Lista = () => [
                    { funcao: 'First', descricao: 'funcao-primeiro' },
                    { funcao: 'Last', descricao: 'funcao-ultimo' },
                    { funcao: 'Min', descricao: 'funcao-minimo' },
                    { funcao: 'Max', descricao: 'funcao-maximo' },
                    { funcao: 'Sum', descricao: 'funcao-soma' },
                    { funcao: 'Avg', descricao: 'funcao-media' },
                    { funcao: 'Count', descricao: 'funcao-contador' },
                    { funcao: 'GroupBy', descricao: 'funcao-agrupamento' },
                    //{funcao: 'OrderBy', descricao: 'funcao-ordenacao'}, //nao fica nessa lista pq não pode ser adicionado como opção nas telas

                    //** cuidado ao adicionar novas funcoes, o medidor de barras utiliza as funcoes do Util.js que estão em camelcase mesmo recebendo essa lista aqui ***
                    //** ou seja, ao adicionar uma funcao aqui, tipo o GroupBy, lá no Util.js deve existir a mesma funcao em camelcase: groupBy ****
                ];

                //primeiro
                funcoes.First = (campo, preProcessamento) => {
                    var dados = fnDados();
                    return ((dados) => dados.length ? dados[0][campo] : null)((preProcessamento || ((dados) => dados))(dados));
                };

                //ultimo
                funcoes.Last = (campo, preProcessamento) => {
                    var dados = fnDados();
                    return ((dados) => dados.length ? dados[dados.length - 1][campo] : null)((preProcessamento || ((dados) => dados))(dados));
                };

                //min
                funcoes.Min = (campo, preProcessamento) => {
                    var dados = fnDados();
                    return ((dados) => funcoesMatematicas.min(dados, campo))((preProcessamento || ((dados) => dados))(dados));
                };

                //max
                funcoes.Max = (campo, preProcessamento) => {
                    var dados = fnDados();
                    return ((dados) => funcoesMatematicas.max(dados, campo))((preProcessamento || ((dados) => dados))(dados));
                };

                //soma
                //Função sum e avg pode retornar null, caso de algum problema considerar o contexto dessa tarefa #124448 e olhar a explicação do commit c91ad55cc7f1b3b7eaf9d7bfc7d09910e745cd0d
                funcoes.Sum = (campo, preProcessamento) => {
                    var dados = fnDados();
                    return ((dados) => funcoesMatematicas.sum(dados, campo))((preProcessamento || ((dados) => dados))(dados));
                };

                //media
                funcoes.Avg = (campo, preProcessamento) => {
                    var dados = fnDados();
                    return ((dados) => funcoesMatematicas.avg(dados, campo))((preProcessamento || ((dados) => dados))(dados));
                };

                //group
                funcoes.GroupBy = (camposAgrupamento, campoValor, preProcessamento) => {
                    var dados = fnDados();
                    return ((dados) => funcoesMatematicas.groupBy(dados, camposAgrupamento, campoValor))((preProcessamento || ((dados) => dados))(dados));
                };

                //contador
                funcoes.Count = (...args) => {
                    var dados = fnDados();
                    //as vezes a funcao depreprocessamento nao vem no primeiro item do argumento
                    var preProcessamento = args.find(a => a.constructor.name == 'Function');
                    return ((dados) => dados.length)((preProcessamento || ((dados) => dados))(dados));
                };

                //order
                funcoes.OrderBy = (propriedade, preProcessamento) => {
                    const _this = this;
                    var dados = fnDados();
                    return ((dados) => _this.ordenarPor(dados, propriedade))((preProcessamento || ((dados) => dados))(dados));
                }

                //unique
                funcoes.Unique = (camposAgrupamento, preProcessamento) => {
                    var dados = fnDados();
                    return ((dados) => funcoesMatematicas.unique(dados, camposAgrupamento))((preProcessamento || ((dados) => dados))(dados));
                };

                //distinct
                funcoes.Distinct = (camposAgrupamento, preProcessamento) => {
                    var dados = fnDados();
                    return ((dados) => funcoesMatematicas.distinct(dados, camposAgrupamento))((preProcessamento || ((dados) => dados))(dados));
                };

                return funcoes;
            },

            abreAccordionPaiValidacao(validador, foco) {
                let pai = validador.validate().brokenRules[0].validator.$element()[0];
                let contMax = 30;
                let cont = 0;
                while (pai && cont < contMax) {
                    cont++;
                    if (pai.classList.contains("dx-accordion-item")) {
                        cont = contMax;
                        if (!pai.classList.contains("dx-accordion-item-opened"))
                            pai.click();
                        if (foco) {
                            setTimeout(() => {
                                validador.validate().brokenRules[0].validator.focus()
                            }, 500);
                        }
                    }
                    else
                        pai = pai.parentNode;
                }
            },

            formatBytes(bytes, decimals) {
                if (bytes == 0) return '0 Bytes';
                var k = 1024,
                    dm = decimals <= 0 ? 0 : decimals || 2,
                    sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
                    i = Math.floor(Math.log(bytes) / Math.log(k));
                return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
            },

            memorySizeOf(obj, formatado) {
                var bytes = 0;

                function sizeOf(obj) {
                    if (obj !== null && obj !== undefined) {
                        switch (typeof obj) {
                            case 'number':
                                bytes += 8;
                                break;
                            case 'string':
                                bytes += (new TextEncoder().encode(obj)).length; //obj.length * 2;
                                break;
                            case 'boolean':
                                bytes += 4;
                                break;
                            case 'object':
                                var objClass = Object.prototype.toString.call(obj).slice(8, -1);
                                if (objClass === 'Object' || objClass === 'Array') {
                                    for (var key in obj) {
                                        if (!obj.hasOwnProperty(key)) continue;
                                        sizeOf(obj[key]);
                                    }
                                } else bytes += obj.toString().length * 2;
                                break;
                        }
                    }
                    return bytes;
                };

                return formatado ? this.formatBytes(sizeOf(obj)) : sizeOf(obj);
            },

            pwaInstalado() {
                return window.matchMedia('(display-mode: standalone)').matches
            },

            goTo(url, novaGuia = true) {
                let win = window.open(url, (novaGuia && !this.pwaInstalado()) ? '_blank' : '_self')
                return win
            },

            isTablet() {
                //return /(ipad|tablet|(android(?!.*mobile))|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(navigator.userAgent.toLowerCase())
                let md = new MobileDetect(navigator.userAgent.toLowerCase())
                return !!md.tablet()
            },

            isMobile() {
                let md = new MobileDetect(navigator.userAgent.toLowerCase())
                return !!md.phone()
            },

            getDispositivo() {
                if (window.innerWidth < 901 || this.isMobile())
                    return 'mobile'
                else if (window.innerWidth < 1201 || this.isTablet())
                    return 'tablet'
                else
                    return 'desktop'
            },

            jsonToFile(content, fileName, contentType) {
                var a = document.createElement("a");
                var file = new Blob([content], { type: contentType });
                a.href = URL.createObjectURL(file);
                a.download = fileName;
                a.click();
            },

            hashCode(txt) {
                if (!txt)
                    return
                var hash = 0, i, chr;
                if (typeof txt == 'object')
                    txt = JSON.stringify(txt)
                if (txt.length === 0) return hash;
                for (i = 0; i < txt.length; i++) {
                    chr = txt.charCodeAt(i);
                    hash = ((hash << 5) - hash) + chr;
                    hash |= 0; // Convert to 32bit integer
                }
                return hash;
            },

            getBotoesPadrao(clickConfirmar, clickCancelar) {
                return [{
                    widget: "dxButton",
                    location: "after",
                    toolbar: "bottom",
                    options: {
                        text: this.globalize("btn-confirmar"),
                        icon: this.ICONE_CONFIRMAR,
                        type: "default",
                        useSubmitBehavior: false,
                        onClick: clickConfirmar
                    }
                },
                {
                    widget: "dxButton",
                    location: "after",
                    toolbar: "bottom",
                    options: {
                        text: this.globalize("btn-cancelar"),
                        icon: "revert",
                        type: "default",
                        onClick: clickCancelar
                    }
                }]
            },

            corrigeInvalidDate(filtroEdit, filtroExec) {
                if (!filtroEdit)
                    return
                const associa = (fe, fex) => {
                    if (!Array.isArray(fex))
                        return
                    if (Array.isArray(fex[0])) {
                        fex.filter(f => Array.isArray(f) && f[2] == "Invalid Date").forEach(f => {
                            f[2] = fe[2]
                        })
                    } else if (fex[2] == "Invalid Date") {
                        fex[2] = fe[2]
                    }
                }

                if (Array.isArray(filtroEdit[0])) {
                    filtroEdit.forEach((fe, index) => {
                        if (Array.isArray(fe)) {
                            if (Array.isArray(fe[0])) {
                                this.corrigeInvalidDate(fe, filtroExec[index])
                            } else {
                                associa(fe, filtroExec[index])
                            }
                        }
                    })
                } else {
                    associa(filtroEdit, filtroExec)
                }
            },

            getFilterOperations: (dataType) => {
                switch (dataType) {
                    case "string":
                        return ["contains", "notcontains", "startswith", "endswith", "=", "<>", "isblank", "isnotblank"];
                    case "number":
                    case "numeric":
                        return ["=", "<>", "<", ">", "<=", ">=", "between", "isblank", "isnotblank"];
                    case "datetime":
                    case "date":
                        return ["=", "<>", "<", ">", "<=", ">=", "between", "isblank", "isnotblank"];
                    case "boolean":
                        return ["=", "<>", "isblank", "isnotblank"];
                    case "object":
                        return ["isblank", "isnotblank"];
                    default:
                        return [];
                }
            },
            removeAutoComplete(e) {
                //remove auto complete
                //associar qualter texto inválido já funciona, 'off' nem sempre
                e.element.querySelector('input').autocomplete = "nope"
            },

            // Deixa a cor mais escura ou mais clara
            // Ex. pSBC(0.4, 'blue', false, true), // 40% mais claro
            // Ex. pSBC(-0.5, 'blue', false, true), // 50% mais escuro
            pSBC(p, c0, c1, l) {
                let r, g, b, P, f, t, h, i = parseInt, m = Math.round, a = typeof (c1) == "string";
                if (typeof (p) != "number" || p < -1 || p > 1 || typeof (c0) != "string" || (c0[0] != 'r' && c0[0] != '#') || (c1 && !a)) return null;
                if (!this.pSBCr) this.pSBCr = (d) => {
                    let n = d.length, x = {};
                    if (n > 9) {
                        [r, g, b, a] = d = d.split(","), n = d.length;
                        if (n < 3 || n > 4) return null;
                        x.r = i(r[3] == "a" ? r.slice(5) : r.slice(4)), x.g = i(g), x.b = i(b), x.a = a ? parseFloat(a) : -1
                    } else {
                        if (n == 8 || n == 6 || n < 4) return null;
                        if (n < 6) d = "#" + d[1] + d[1] + d[2] + d[2] + d[3] + d[3] + (n > 4 ? d[4] + d[4] : "");
                        d = i(d.slice(1), 16);
                        if (n == 9 || n == 5) x.r = d >> 24 & 255, x.g = d >> 16 & 255, x.b = d >> 8 & 255, x.a = m((d & 255) / 0.255) / 1000;
                        else x.r = d >> 16, x.g = d >> 8 & 255, x.b = d & 255, x.a = -1
                    } return x
                };
                h = c0.length > 9, h = a ? c1.length > 9 ? true : c1 == "c" ? !h : false : h, f = this.pSBCr(c0), P = p < 0, t = c1 && c1 != "c" ? this.pSBCr(c1) : P ? { r: 0, g: 0, b: 0, a: -1 } : { r: 255, g: 255, b: 255, a: -1 }, p = P ? p * -1 : p, P = 1 - p;
                if (!f || !t) return null;
                if (l) r = m(P * f.r + p * t.r), g = m(P * f.g + p * t.g), b = m(P * f.b + p * t.b);
                else r = m((P * f.r ** 2 + p * t.r ** 2) ** 0.5), g = m((P * f.g ** 2 + p * t.g ** 2) ** 0.5), b = m((P * f.b ** 2 + p * t.b ** 2) ** 0.5);
                a = f.a, t = t.a, f = a >= 0 || t >= 0, a = f ? a < 0 ? t : t < 0 ? a : a * P + t * p : 0;
                if (h) return "rgb" + (f ? "a(" : "(") + r + "," + g + "," + b + (f ? "," + m(a * 1000) / 1000 : "") + ")";
                else return "#" + (4294967296 + r * 16777216 + g * 65536 + b * 256 + (f ? m(a * 255) : 0)).toString(16).slice(1, f ? undefined : -2)
            },

            // getCorPaleta(obj) {

            //     if (obj == undefined)
            //         return undefined;

            //     if (typeof obj == 'string')
            //     {
            //         if (obj.length)
            //             return obj;
            //         return undefined;
            //     }

            //     if (!Object.keys(obj).length)
            //         return undefined;

            //     if (obj != undefined && store.getters.paletasCores.length > 0){
            //         if (obj.id == undefined || obj.id == -1)
            //             return obj
            //         return store.getters.paletasCores.find(p => p.id == obj.idPaleta)?.cores?.find(c => c.id == obj.id)
            //     }
            // },

            larguraMinimaEditor: 300, //largura mínima dos editores para responsividades de formulários

            ExecucaoFontesDados,
            ...expression,
            ...localization,
            ...funcoesMatematicas,
            ...Tipos(app),
            ...mergeObjects,
            ...NumberFormat,
            ...DateFormat,
            ...Estilos(app),
            ...dom2,
            ...objetos,
            ...Painel,
            ...Ajuda(app)
        }

    }
}

export {
    DCUtil,
    DCPlugin
}